import React, { Component } from 'react';
import { fromJS } from 'immutable';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Moment from 'moment';
import withSizes from 'react-sizes';
import View from '../../../utils/viewHelpers';
import PageTitle from '../../../components/commons/pages/PageTitle';
import ProductList from '../../../components/cart/ProductList';
import ProductListMobile from '../../../components/cart/ProductListMobile';
import BillDetails from '../../../components/checkout/BillDetails';
import BillDetailsMobile from '../../../components/cart/BillDetailsMobile';
import DeliveryDetailsMobile from '../../../components/checkout/DeliveryDetailsMobile';
import PaymentCards from '../../../components/checkout/PaymentCards';
import PaymentCardsMobile from '../../../components/checkout/PaymentCardsMobile';
import Loader from '../../../components/commons/loader/loader';
import * as Utils from '../../../utils/utils';
import * as User from '../../../utils/userHelpers';
import * as Cart from '../../../utils/cartHelper';
import * as Orders from '../../../utils/ordersHelper';
import * as Payments from '../../../services/payments';
import * as ApiHelper from '../../../utils/apiHelper';
import * as UserActions from '../../../actions/userActions';
import * as OrdersActions from '../../../actions/ordersActions';
import * as PaymentsActions from '../../../actions/paymentsActions';
import SweetAlert from 'sweetalert-react';

class PlaceOrderPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cartItems: {},
      billDetails: {},
      placeOrderSuccess: false,
      showAlert: false,
      swalParams: {
        title: ""
      },
      isReady: false,
      dataLoaded: false
    }

    this.placeOrder = this.placeOrder.bind(this);
    this.goBack = this.goBack.bind(this);
    this.doOnCartChanged = this.doOnCartChanged.bind(this);
    this.renderContentIfCartHasProducts = this.renderContentIfCartHasProducts.bind(this);
    this.renderContentIfCartHasProductsForMobile = this.renderContentIfCartHasProductsForMobile.bind(this)
    this.renderNoProductsInCartMessage = this.renderNoProductsInCartMessage.bind(this);
    this.renderUserNotLoggedInMessage = this.renderUserNotLoggedInMessage.bind(this);
    this.renderOrderSuccessMessage = this.renderOrderSuccessMessage.bind(this);

  }

  componentDidMount() {

    if (!User.isLoggedIn()) {
      return;
    } else {
      this.setState({ isUserLoggedIn: true });
      this.props.dispatch(UserActions.getProfileDetails(response => {
        console.log("GET_USER_RESPONSE", response);
        if (response.status) {
          let user = response.data;
          this.props.dispatch(PaymentsActions.getAllCards(getCardsResponse => {
            console.log("GET_ALL_CARDS_RESPONSE", getCardsResponse);
            if (getCardsResponse.status) {
              let paymentMethodId = Cart.getCartAttribute(Cart.ATTRIBUTE_PAYMENT_METHOD_ID);
              this.setState({
                userAddresses: user.addresses,
                cards: getCardsResponse.data,
                selectedCardId: paymentMethodId,
                selectedCard: Payments.getPaymentMethodById(paymentMethodId, getCardsResponse.data),
                dataLoaded: true
              }, () => this.doOnCartChanged())
            } else {
              this.setState({
                showAlert: true, swalParams: {
                  title: "Something went wrong!",
                  type: "error",
                  showConfirmButton: false
                }
              })
            }
          }));
        }
      }))
    }
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }

  render() {

    const {
      isReady,
      isUserLoggedIn,
      cartItems,
      showAlert,
      swalParams,
      dataLoaded,
      placeOrderSuccess,
    } = this.state;

    const { isMobile, productsLoading, ordersLoading, recentOrder } = this.props;
    const cartItemList = cartItems ? Object.values(cartItems) : [];

    return (
      <div className={`page checkout-page ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          <PageTitle title="Review & Place Order" isMobile />
          {isUserLoggedIn && isReady
            ? (cartItemList.length > 0 && !placeOrderSuccess)
            ? isMobile
            ? this.renderContentIfCartHasProductsForMobile(cartItemList)
            : this.renderContentIfCartHasProducts(cartItemList)
            : null
            : this.renderUserNotLoggedInMessage()}

          {((cartItemList && cartItemList.length == 0) && (!placeOrderSuccess) && (isUserLoggedIn)) && dataLoaded
            ? this.renderNoProductsInCartMessage()
            : null}

          {placeOrderSuccess && recentOrder && isUserLoggedIn && isReady
            ? this.renderOrderSuccessMessage()
            : null}

        </div>
        <Loader visibility={productsLoading || ordersLoading || !dataLoaded} />
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={() => this.setState({ showAlert: false })} show={showAlert} {...swalParams} onConfirm={() => this.setState({ showAlert: false })} />
      </div>
    )
  }

  renderContentIfCartHasProducts(cartItemList) {
    const {
      billDetails,
      isTimeNowSelected,
      deliveryTime,
      deliveryNotes,
      selectedCard,
      deliveryAddress,
      giftDelivery,
      giftDeliveryDetails
    } = this.state;
    const { cards } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col-md-7 left-col">

            <div className="info-group">
              <div className="info-body">
                <ProductList products={cartItemList} viewMode="view" />
              </div>
            </div>

            <div className="info-group">
              <div className="info-title">Delivery Details</div>
              <div className="info-body">
                {giftDelivery ?
                  <div className="gift-delivery-details-container">
                    <div className="recipient-details edited">
                      <div className="section-title">GIFT DELIVERY Recipient Details</div>
                      {giftDeliveryDetails.recipientName ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.recipientName}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.recipientBusinessName ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.recipientBusinessName}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.recipientAddress ?

                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.recipientAddress.apartment ? `Apartment #: ${giftDeliveryDetails.recipientAddress.apartment}` : ''} &nbsp;
                    {giftDeliveryDetails.recipientAddress.description}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.recipientEmail ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.recipientEmail}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.recipientPhone ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.recipientPhone}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.giftMessage ?
                        <div className="info-row">GIFT MESSAGE: &nbsp;
                <span className="text-italic">
                            {giftDeliveryDetails.giftMessage}
                          </span>
                        </div>
                        : null
                      }
                    </div>
                    <div className="sender-details edited">
                      <div className="section-title">SENDER DETAILS</div>
                      {giftDeliveryDetails.senderName ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.senderName}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.senderBusinessName ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.senderBusinessName}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.senderAddress ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.senderAddress.apartment ? `Apartment #: ${giftDeliveryDetails.senderAddress.apartment}` : ''} &nbsp;
                      {giftDeliveryDetails.senderAddress.description}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.senderEmail ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.senderEmail}
                          </span>
                        </div>
                        : null
                      }
                      {giftDeliveryDetails.senderPhone ?
                        <div className="info-row">
                          <span className="text-italic">
                            {giftDeliveryDetails.senderPhone}
                          </span>
                        </div>
                        : null
                      }
                      <div className="info-row">SENDER DOB: &nbsp;
                        <span className="text-italic">
                          {giftDeliveryDetails.senderDOB ? Moment(giftDeliveryDetails.senderDOB).format('L') : 'Not provided'}
                        </span>
                      </div>
                    </div>
                  </div>
                  :
                  <div className="info-row">Delivery to: &nbsp;
                  <span className="text-italic">{deliveryAddress
                      ? deliveryAddress.apartment ? `Apartment #: ${deliveryAddress.apartment}, ${deliveryAddress.description}` : deliveryAddress.description
                      : 'Not provided'}</span>
                  </div>

                }
                <div className="info-row">Schedule Delivery: &nbsp;
                  <span className="text-italic">{isTimeNowSelected
                    ? 'Now'
                    : `${Moment(deliveryTime.start).format('MM-DD-YYYY')}, ${deliveryTime.start ? Moment(deliveryTime.start).format('hh:mma') : ''}${deliveryTime.end ? ' - ' + Moment(deliveryTime.end).format('hh:mma') : ''}`}</span>
                </div>
                <div className="info-row">Delivery Notes: &nbsp;
                  <span className="text-italic">{deliveryNotes
                    ? deliveryNotes
                    : 'Not provided'}</span>
                </div>
              </div>
            </div>

            <div className="info-group">
              <div className="info-title">Payment Information</div>
              <div className="info-body">
                <div className="info-row">{selectedCard
                  ? `${selectedCard.brand}: XXXXXXXXXXXX ${selectedCard.last4}`
                  : 'Not selected'}</div>
                <div className="info-row"></div>
              </div>
            </div>

            {/* <div className="info-group">
              <div className="info-title">Billing Address</div>
              <div className="info-body">
                <div className="info-row">
                  <span className="text-italic">{billingAddress
                    ? billingAddress
                    : 'Not provided'}</span>
                </div>
              </div>
            </div> */}

          </div>
          <div className="col-md-5 right-col">
            <div className="info-group">
              <div className="info-title">Order Summary</div>
              <div className="info-body">
                <BillDetails billDetails={billDetails} viewMode="view" />
              </div>
            </div>
            <div className="info-group">
              {this.renderDeliveryScheduleInfo()}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            { !giftDelivery &&
                <div className="text-center text-error">MATCHING CREDIT CARD AND ID MUST BE PRESENT FOR ALL DELIVERIES.</div>
            }

            <div className="footer-buttons-container">
              <a href="javascript:void(0)" className="button-back" onClick={() => this.goBack()}>Back</a>
              <a href="javascript:void(0)" className="button-review-order" onClick={() => this.placeOrder()}>Place your Order</a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderContentIfCartHasProductsForMobile(cartItemList) {
    const { cards } = this.props;
    const {
      billDetails,
      isDeliveryDetailsEditable,
      isBillingAddressEditable,
      giftDelivery,
      giftDeliveryDetails,
      newCardData,
      selectedCard,
      userAddresses,
      deliveryAddress,
      deliveryNotes,
      deliveryTime,
      isTimeNowSelected
    } = this.state;

    return (
      <div>

        <a href="javascript:void(0)" className="button button-block button-blue" onClick={() => this.placeOrder()}>Place your Order</a>

        <ProductListMobile viewMode={"view"} products={cartItemList} />

        <BillDetailsMobile billDetails={billDetails} viewMode={"view"} />

        <div className="section-header">PAYMENT INFORMATION</div>
        <PaymentCardsMobile selectedCard={selectedCard} />

        <div className="section-header">DELIVERY DETAILS</div>
        <DeliveryDetailsMobile
          deliveryAddress={deliveryAddress}
          deliveryNotes={deliveryNotes}
          isTimeNowSelected={isTimeNowSelected}
          deliveryTime={deliveryTime}
          isGiftSwitchOn={giftDelivery}
          giftDeliveryDetails={giftDeliveryDetails}/>

          <div className="row footer-row-mobile">
            <div className="col-md-12">
             {  !giftDelivery &&
                <div className="text-center text-error">MATCHING CREDIT CARD AND ID MUST BE PRESENT FOR ALL DELIVERIES.</div>
             }
              <div className="footer-buttons-container">
                <a href="javascript:void(0)" className="button button-block button-dark-grey" onClick={() => this.goBack()}>Back</a>
              </div>
            </div>
          </div>

      </div>
    )
  }

  renderNoProductsInCartMessage() {
    return (
      <div className="message-container">
        <div className="title">No order to checkout</div>
        <div className="links">
          <Link to="/">Continue Shopping</Link>
        </div>
      </div>
    )
  }

  renderUserNotLoggedInMessage() {
    const { isReady } = this.state;
    return isReady ? (
      <div className="message-container">
        <div className="title">You are not logged in</div>
        <div className="links">
          <Link to="/signin">Please login to continue</Link>
        </div>
      </div>
    ) : null;
  }

  renderOrderSuccessMessage() {
    const { recentOrder } = this.props;
    return (
      <div className="message-container">
        <div className="title">Your order placed successfully</div>
        <div className="links">
          <Link to="/">Continue Shopping</Link>
          <Link to={`/orders/${recentOrder._id}`}>View Order</Link>
        </div>
      </div>
    )
  }

  renderDeliveryScheduleInfo() {
    return (
      <div className="row info-schedule-container">
        <div className="info">Hours of Operations:</div>
        <div className="info">Mon – Sun: 9am to 2am</div>
        <div className="info">365 days!<br />Delivery available ALL DAY!</div>
      </div>
    )
  }

  goBack() {
    this.props.history.goBack();
  }

  doOnCartChanged() {

    const { userAddresses } = this.state;

    const giftDelivery = Cart.getCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY);
    const giftDeliveryDetails = Cart.getCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY_DETAILS);
    let cart = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_STORE);
    let cartItems = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? cart[Cart.ATTRIBUTE_CART_ITEMS]
      : {};
    let deliveryDate = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_DATE);
    let deliveryTimeInterval = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME);
    let deliveryNotes = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_NOTES);
    let deliverySlot = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_SLOT);
    let isSameAsDeliveryAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS);
    let storedAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS);
    let storedBillingAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_BILLING_ADDRESS);
    let addresses = userAddresses.filter(address => storedAddress && address._id === storedAddress._id);
    let deliveryAddress = addresses.length == 1 ? addresses[0] : giftDelivery ? giftDeliveryDetails.recipientAddress : false;
    let tipPercentage = Cart.getCartAttribute(Cart.ATTRIBUTE_TIP_PERCENT);

    this.setState({
      cartItems: cartItems,
      deliveryDate: deliveryDate,
      deliveryTime: deliveryTimeInterval,
      isTimeNowSelected: deliveryTimeInterval && deliveryTimeInterval.start === 'now',
      deliveryNotes: deliveryNotes,
      tipPercentage: tipPercentage,
      deliveryAddress: deliveryAddress,
      billingAddress: isSameAsDeliveryAddress ? (deliveryAddress ? deliveryAddress.description : '') : storedBillingAddress,
      giftDeliveryDetails,
      giftDelivery,
      deliverySlot
    });

    let cartItemList = Object.values(cartItems);
    if (cartItemList.length == 0) {
      console.warn('Cart is empty')
      return;
    }

    let tempOrder = Orders.buildTempOrderData(cartItemList)
    console.log("TEMP_ORDER_PAYLOAD", tempOrder);
    this.props.dispatch(OrdersActions.createTempOrder(tempOrder, response => {
      console.log("ORDER_CHECK_RESPONSE", response);
      if (response.status) {
        let billData = Orders.calculateBill(response.data);
        this.setState({ billDetails: billData, tempOrder: response.data, isReady: true });
      } else {
        this.setState({
          showAlert: true, swalParams: {
            title: 'Something went wrong!',
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
  }

  placeOrder() {

    const {
      cartItems,
      deliveryDate,
      deliveryTime,
      isTimeNowSelected,
      deliveryNotes,
      tipPercentage,
      billDetails,
      selectedCard,
      deliveryAddress,
      billingAddress,
      giftDelivery,
      giftDeliveryDetails,
      deliverySlot
    } = this.state;
    //const selectedCard = Payments.getPaymentMethodById(selectedCardId, cards);

    let error = [];
    if (!selectedCard)
      error.push('Please select payment method');
    if (!deliveryAddress)
      error.push('Please select delivery address');
    if (!isTimeNowSelected && !deliveryTime)
      error.push('Please select delivery time');

    if (error.length > 0) {
      this.setState({
        showAlert: true, swalParams: {
          title: "Validation Error",
          text: error.join('\n'),
          type: "warning"
        }
      })
    } else {

        if (billDetails.total < 8.5) {
          this.setState({
            showAlert: true, swalParams: {
              title: 'Sorry you must spend at least $8.50 for delivery',
              type: "warning",
              showConfirmButton: false
            }
          })
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        } else {

          let tempOrder = Utils.toJS(fromJS(this.state.tempOrder));
          if (!tempOrder) {
            this.setState({
              showAlert: true, swalParams: {
                title: "Something went wrong!",
                type: "error",
                showConfirmButton: false
              }
            })
            // setTimeout(() => this.setState({showAlert: false}), 2000);
            return;
          }

          console.log("TEMP_ORDER", tempOrder);
          tempOrder.creditCard = selectedCard.id;
          tempOrder.stripeID = selectedCard.customer;
          tempOrder.deliveryNote = deliveryNotes;
          tempOrder.deliverySlot = deliverySlot;
          tempOrder.address = deliveryAddress;
          tempOrder.tipPercentage = tipPercentage ? tipPercentage : 0;

          tempOrder.billingAddress = {
            description: billingAddress
          }

          tempOrder.deliveryStartTime = deliveryTime.start;
          tempOrder.deliveryEndTime = deliveryTime.end;

          tempOrder.deliverNow = isTimeNowSelected;
          tempOrder.deliveryDate = Moment(deliveryDate).format('MM/DD/YY').toString();
          tempOrder.strDeliveryStartTime = Moment(deliveryTime.start).format('HH:mm').toString();
          tempOrder.strDeliveryEndTime = Moment(deliveryTime.end).format('HH:mm').toString();
          tempOrder.deliveryDateObj = Moment(deliveryDate).toDate();
          tempOrder.giftDelivery = giftDelivery;
          tempOrder.giftDeliveryDetails = giftDeliveryDetails;

          console.log("ORDER_PAYLOAD", tempOrder);

          this.props.dispatch(OrdersActions.placeOrder(tempOrder, response => {
            if (response.status) {
              Cart.clearCart();
              this.setState({ placeOrderSuccess: true });
              const transactionId = response.data.order?response.data.order.transactionID.slice(-6).toUpperCase():undefined;

              if(__GTAG__CONVERSION__ && transactionId) {
                gtag('event', 'conversion', { 'send_to': 'AW-802355097/EW8pCPeFwIMBEJnvy_4C', 'transaction_id': transactionId });
              }

              const { order } = response.data;
              const products = order.products.map(p => ({
                id: p._id,
                ...p
              }));
              window.dataLayer.push({
                event: 'purchase',
                ecommerce: {
                  purchase: {
                    actionField: {
                      id: transactionId,
                      ...order
                    },
                    products
                  }
                }
              });
            } else {
              this.setState({
                showAlert: true, swalParams: {
                  title: (response && response.data && response.data.error) ?
                    response.data.error.message :
                    "Failed to process your order, please try again later!",
                  type: "error",
                  showConfirmButton: false
                }
              })
              // setTimeout(() => this.setState({showAlert: false}), 2000);
            }
          }))
        }


    }

  }

}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    user: state.getIn(['users', 'user']),
    cards: state.getIn(['payments', 'cards']),
    productsLoading: state.getIn(['products', 'loading']),
    ordersLoading: state.getIn(['orders', 'loading']),
    recentOrder: state.getIn(['orders', 'recentOrder']),
    error: state.getIn(['products', 'error'])
  };
})(PlaceOrderPage));



// WEBPACK FOOTER //
// ./src/containers/billing/checkout/PlaceOrderPage.js